import SliderNavButton from '@/components/Slider/components/SliderNavButton/SliderNavButton';
import SliderPlayPauseButton from '@/components/Slider/components/SliderPlayPauseButton/SliderPlayPauseButton';

import styles from './SliderFooter.module.css';

import type { MutableRefObject } from 'react';

type SliderFooterProps = {
  showNavigation: boolean;
  isPaginationEnabled: boolean;
  shouldShowPlayPause: boolean;
  isAutoplayRunning: boolean;
  isAutoplayEnabled: boolean;
  toggleAutoplayHandler: (() => void) | null;
  prevRef: MutableRefObject<HTMLButtonElement | null>;
  nextRef: MutableRefObject<HTMLButtonElement | null>;
  paginationRef: MutableRefObject<HTMLDivElement | null>;
};

const SliderFooter = ({
  showNavigation,
  isPaginationEnabled,
  shouldShowPlayPause,
  isAutoplayRunning,
  isAutoplayEnabled,
  toggleAutoplayHandler,
  prevRef,
  nextRef,
  paginationRef,
}: SliderFooterProps) => {
  const centerControls = (
    <div className={styles.centerControls}>
      {isPaginationEnabled && <div ref={paginationRef} className={styles.pagination} />}
      {shouldShowPlayPause && (
        <SliderPlayPauseButton
          isRunning={isAutoplayRunning}
          onToggle={() => toggleAutoplayHandler?.()}
          disabled={!isAutoplayEnabled || !toggleAutoplayHandler}
        />
      )}
    </div>
  );

  return (
    <div className={styles.footer}>
      {showNavigation ? (
        <div className={styles.navButtons}>
          <SliderNavButton ref={prevRef} direction="prev" />
          {centerControls}
          <SliderNavButton ref={nextRef} direction="next" />
        </div>
      ) : (
        centerControls
      )}
    </div>
  );
};

export default SliderFooter;
